import React from 'react';
import Inventory from '../assets/inventory.png'
import RPS from '../assets/rps.png'
import ProjectCard from './ProjectCard';
import { motion } from 'framer-motion';


const ProjectSection = () => {
  const projects = [
    {
      title: 'Trackify Inventory',
      description:
        'A full-stack inventory management system built for managing and tracking stock in real-time.',
      thumbnail: Inventory,
      tags: ['React', 'Express', 'React Query', 'Tailwindcss'],
      githubLink: 'https://github.com/ayoashy/inventory-tracker',
      liveUrl: 'https://inventory-tracker-frontend.vercel.app',
      demoVideo: 'https://www.youtube.com/watch?v=--Mt-M3W8mY',
    },
    {
      title: 'ChainPlay RPS(Rock Paper Scissors DApp)',
      description:
        'A blockchain-based game using Solidity and Web3 technologies deployed on telegram.',
      thumbnail: RPS,
      tags: ['NextJs','Solidity', 'foundry', 'Tailwindcss', 'wagmi'],
      githubLink: 'https://github.com/ayoashy/rps-client',
      demoVideo: 'https://youtu.be/D0drEd5BIFw',
      telegramLink: 'https://t.me/PlayChainRPS_bot',
      liveUrl: 'https://rps-client-ten.vercel.app/',
    },
  ];

    const sectionVariants = {
      hidden: { opacity: 1 },
      visible: {
        opacity: 1,
        transition: {
          staggerChildren: 0.2,
          when: 'beforeChildren',
        },
      },
    };

    const lineVariants = {
      hidden: { scaleX: 0 },
      visible: { scaleX: 1, transition: { duration: 0.5 } },
    };

    const headerVariants = {
      hidden: { opacity: 1, y: -30 },
      visible: { opacity: 1, y: 0, transition: { duration: 0.6 } },
    };

  return (
    <motion.section
      className='bg-[#080808] text-white p-6 md:p-12 min-h-[100vh]'
      name='projects'
      initial='hidden'
      whileInView='visible'
      viewport={{ once: true, amount: 0.2 }}
      variants={sectionVariants}
    >
      {/* Section Header */}
      <div className='flex items-center px-[2%] mt-[100px]'>
        <motion.div
          className='w-full h-[1px] bg-[#353535]'
          variants={lineVariants}
        ></motion.div>
        <motion.p
          className='text-xl md:text-3xl text-center font-bold mx-3 text-[#4d760c] mb-4'
          variants={headerVariants}
        >
          Projects
        </motion.p>
        <motion.div
          className='w-full h-[1px] bg-[#353535]'
          variants={lineVariants}
        ></motion.div>
      </div>

      {/* Projects Grid */}
      <motion.div
        className='grid grid-cols-1 md:grid-cols-2 gap-8'
        variants={sectionVariants}
      >
        {projects.map((project, index) => (
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ delay: index * 0.2, duration: 0.5 }}
          >
            <ProjectCard project={project} />
          </motion.div>
        ))}
      </motion.div>
    </motion.section>
  );
};

export default ProjectSection;
